import {SortingFn} from '@tanstack/react-table';

import {TanStackTableData} from 'components/Table/core/types';

const numericSorting: SortingFn<TanStackTableData> = (rowA, rowB, columnId) => {
  const a = rowA.original[columnId] as number | null;
  const b = rowB.original[columnId] as number | null;

  if (a === null && b === null) return 0;
  if (a === null) return 1;
  if (b === null) return -1;

  return a - b;
};

export {numericSorting};
